import React from "react";
import InfoImage from "../../assets/backgrounds/info-image.webp";
import Modal from 'react-bootstrap/Modal';
import { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Info.scss"


export const GradeInfo = () => {

    const [show, setShow] = useState(true);
    let history = useHistory();


    const handleClose = () => {
        setShow(false);
        history.push({
            pathname: `/score`,
        });
    };

    return (

        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton style={{ border: "0px" }}>
            </Modal.Header>
            <Modal.Body>
                <div className="container grade-info-modal">
                    <h5 className="px-4">
                        eGrade es un servicio digital para apoyarte a la hora de establecer relaciones comerciales con otras empresas.
                    </h5>
                    <p className="px-4 pt-3">
                        En tres sencillos pasos:
                    </p>

                    <img className="info-image w-100 py-3" alt="infoimagegrade" src={InfoImage} />
                    <p className="px-4 pt-1">
                        Consulta el eGrade obtenido tantas veces como lo necesites dentro del periodo de vigencia.
                        Además, puedes descargarte la información o recibirla en tu email.
                    </p>
                </div>
            </Modal.Body>
        </Modal>

    )
}